import { Icon, Text, HStack } from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';

import { CustomerWithdrawalItemNormalized } from '../../../../../../../../store/customerDetail/withdrawal/types';

export namespace StatusIconTypes {
  export interface Props {
    item: CustomerWithdrawalItemNormalized;
  }
}

export const StatusIcon: React.FC<StatusIconTypes.Props> = ({ item }) => {
  return (
    <HStack alignItems="center" space={Spacing['stack.quarck']}>
      <Text>{item.statusNormalized}</Text>
      <Icon
        testID="items-table-item-desktop-account-status-icon"
        size={item.statusIconSizeNormalized}
        name={item.statusIconNormalized}
        color={Color[item.statusIconColorNormalized]}
      />
    </HStack>
  );
};
